import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ConfiguratorIcon } from "@svg/hero_black.svg";

export default function ConfiguratorShortcut() {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname.startsWith("/admin")) return null;

  const hiddenWhenHomeIconIsVisible =
    location.pathname === "/" ? "min-[1800px]:hidden" : "";

  return (
    <button
      type="button"
      onClick={() => navigate("/configurator")}
      className={`fixed bottom-6 right-6 z-[80] hidden h-[72px] w-[72px] drop-shadow-[0_8px_24px_rgba(0,0,0,0.22)] transition-transform duration-200 hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#CF5327] md:block lg:bottom-10 lg:right-10 lg:h-[90px] lg:w-[90px] ${hiddenWhenHomeIconIsVisible}`}
      aria-label="Открыть конфигуратор"
      title="Конфигуратор"
    >
      <ConfiguratorIcon className="block h-full w-full" />
    </button>
  );
}
